module.exports = __webpack_public_path__ + "img/Sumitomo_Hansen.293aec8b.jpg";